export const userAgent =
  "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4430.93 NextJS/007.123";
export const flicketLogo = "/static/flicket.png";

export const DOT_SEPARATOR = "•";
